import resume from '../assets/pdf/resume.pdf'
import pic from '../assets/png/pic.jpeg'

export const headerData = {
    name: 'Sachidanand Pradhan',
    title: "Full Stack Web Devloper",
    desciption:"Full-Stack Developer with working experience of more than 2 years. Seeking to leverage broad products development experience and solve real-life problems in a challenging role.",
    image: pic,
    resumePdf: resume
}
